import { render, staticRenderFns } from "./NotificationRetrievalQueryIcon.vue?vue&type=template&id=38db82f0&"
import script from "./NotificationRetrievalQueryIcon.vue?vue&type=script&lang=ts&"
export * from "./NotificationRetrievalQueryIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports